import React from 'react';
import autobind from 'autobind-decorator';
import {Col, Row} from 'react-bootstrap';

import {BaseComponent} from "../../BaseComponent";
import {Conditional} from "../../Conditional";
import {service as ContactService} from "../../../Services/ContactService";
import {service as RelationshipService} from "../../../Services/RelationshipService";
import {service as StateService} from "../../../Services/StateService";

export class ContactList extends BaseComponent {
    constructor() {
        super();

        this.setInitialState({
            states: [],
            relationships: []
        });
    }

    componentDidMount() {
        Promise.all([
            StateService.Get(),
            RelationshipService.Get()
        ])
            .then(([states, relationships]) => {
                this.setState({ states: states.result, relationships: relationships.result });
            });
    }

    @autobind
    getState(stateId) {
        let state = this.state.states.find((x) => x.stateId === stateId);

        if(state) {
            return state.name;
        }

        return "N/A"
    }

    @autobind
    getRelationship(relationshipId) {
        let relationship = this.state.relationships.find((x) => x.relationshipId == relationshipId);

        if(relationship) {
            return relationship.name;
        }

        return "N/A";
    }

    @autobind
    getRelationshipId(name) {
        let relationship = this.state.relationships.find((x) => x.name === name);

        if(relationship) {
            return relationship.relationshipId;
        }

        return -1;
    }

    @autobind
    getContact(contactId) {
        return this.props.Contacts.find((x) => x.stakeholderId === contactId);
    }

    @autobind
    getProjectRoles() {
        if(this.props.ProjectRoles && this.state.relationships.length) {
            let projectRoles = this.props.ProjectRoles;

            //TODO: Sort these in a less hardcoded way
            projectRoles.sort((a, b) => {
                let landowner = this.getRelationshipId("Landowner");
                let projectManager = this.getRelationshipId("Project Manager");
                if(a.relationshipId == landowner) {
                    return -2;
                } else if(b.relationshipId == landowner) {
                    return 2;
                } else if(a.relationshipId == projectManager) {
                    return -1;
                } else if(b.relationshipId == projectManager) {
                    return 1;
                } else {
                    return 0;
                }
            });

            if(this.props.Limit) {
                projectRoles = projectRoles.slice(0, this.props.Limit);
            }

            return projectRoles;
        }

        return [];
    }

    render() {
        return <Row className="sb-contact-list">
            {
                this.getProjectRoles().map((x) => {
                    let contact = this.getContact(x.stakeholderId);

                    const displayName = ContactService.GetTitle(contact);

                    if(contact) {
                        const address = contact.StakeholderAddresses?.Address;

                        return <Col xs={12} key={x.projectStakeholderRelationshipId} className="sb-contact-list-node">
                            <h2 className="sb-children-list-title">{this.getRelationship(x.relationshipId)} Info:</h2>
                            <h4 className="sb-contact-list-node-title">{displayName}</h4>
                            <Conditional Condition={address}>
                                <div className="sb-contact-list-node-address">
                                    <Conditional Condition={address?.email}>
                                        <p><span className="mail-icon glyphicon glyphicon-envelope"></span><a href={"mailto:" + address?.email}>{address?.email}</a></p>
                                    </Conditional>
                                    <Conditional Condition={address?.phone}>
                                        <p><span className="phone-icon glyphicon glyphicon-earphone"></span><a href={"tel:" + address?.phone}>{address?.phone}</a></p>
                                    </Conditional>
                                    <Conditional Condition={address?.address1}>
                                        <p><span className="address-icon glyphicon glyphicon-map-marker"></span>{address?.address1}</p>
                                    </Conditional>
                                    <Conditional Condition={address?.address2}>
                                        <p className="sb-contact-list-node-address2">{address?.address2}</p>
                                    </Conditional>
                                    <p className="sb-contact-list-node-address2">{address?.city},&nbsp;{this.getState(address?.stateId)}&nbsp;{address?.zipcode}</p>
                                </div>
                            </Conditional>
                        </Col>
                    } else {
                        return null;
                    }
                })
            }
        </Row>;
    }
}
